import React from 'react';
import { Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';

export const EmptyState = () => {
  return (
    <div className="flex-grow-1 self-center flex flex-col gap-y-4 items-center justify-center w-88">
      <div className="flex items-center justify-center w-12 h-12 border border-gray-200 rounded-lg shadow-xs">
        <Icon glyph={IconMap.MessageTextSquare03} />
      </div>
      <div className="flex flex-col justify-center items-center gap-y-1 text-center">
        <h3 className="text-gray-900 text-md font-semibold">No comments</h3>
        <p className="text-gray-600 text-sm">
          Be the first to leave a comment.
        </p>
      </div>
    </div>
  );
};
